import React, { useState } from "react";
import UploadElementDialog from "./UploadElementDialog";
import { AppButton } from "../ui";
import useElementUploadWorkflow from "./useElementUploadWorkflow";
import {
  canUploadReplacementModel,
  isElementClone,
} from "../../utility/elementIdentity";

const NewElementUploader = ({ onNewElementCreated, initialElementId, initialElementData }) => {
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const { uploadSingleElement } = useElementUploadWorkflow({
    initialElementId,
    initialElementData,
  });
  const isReplacementUpload = Boolean(initialElementId);
  const replacementUploadAllowed =
    !isReplacementUpload ||
    canUploadReplacementModel(initialElementId, initialElementData);
  const replacementUploadBlocked =
    isReplacementUpload && !replacementUploadAllowed;
  const blockedClone = isElementClone(initialElementData);

  const handleOpenDialog = () => {
    if (replacementUploadBlocked) return;
    setUploadDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setUploadDialogOpen(false);
  };

  const handleUpload = async ({ name, description, file, optimization }) => {
    if (!file || replacementUploadBlocked) {
      return;
    }

    try {
      const createdElement = await uploadSingleElement({
        file,
        name,
        description,
        optimization,
      });

      // Call parent's callback, if provided, to update the list.
      if (onNewElementCreated && !initialElementId) {
        onNewElementCreated(createdElement);
      }

      handleCloseDialog();
    } catch (error) {
      console.error("Error uploading new element:", error);
      throw error;
    }
  };

  return (
    <div className="elementModelUploadControl">
      <AppButton
        onClick={handleOpenDialog}
        disabled={replacementUploadBlocked}
      >
        {isReplacementUpload ? "Upload New Model" : "Upload New Element"}
      </AppButton>
      {replacementUploadBlocked && (
        <span className="elementModelUploadNotice" role="status">
          {blockedClone
            ? "Model uploads are unavailable for cloned elements."
            : "Model upload is unavailable because this element's source identity could not be verified."}
        </span>
      )}
      <UploadElementDialog
        open={uploadDialogOpen}
        onClose={handleCloseDialog}
        onUpload={handleUpload}
      />
    </div>
  );
};

export default NewElementUploader;
